// CHANGES BY KHALID STARTS 15/10/24

// authSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoggedIn: false,
  userData: null,
  token: null, // Add token field
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess(state, action) {
      state.isLoggedIn = true;
      state.userData = action.payload; // Save user data
      state.token = action.payload.token; // Save token separately
      console.log("User data:", state.userData);
      console.log("Token:", state.token);
    },
    logoutSuccess(state) {
      state.isLoggedIn = false;
      state.userData = null;
      state.token = null; // Clear token on logout
    },
  },
});

export const { loginSuccess, logoutSuccess } = authSlice.actions;
export default authSlice.reducer;

// CHANGES BY KHALID ENDS 15/10/24
